export function validatePhoneNumber(phoneNumber) {
    // Remove non-numeric characters
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    
    // Check for a 10-digit phone number starting with 07
    if (/^07\d{8}$/.test(cleanNumber)) {
        return '0' + cleanNumber.slice(1); 
    }

    // Check for 9-digit numbers starting with 7
    if (/^7\d{8}$/.test(cleanNumber)) {
        return '07' + cleanNumber.slice(1); 
    }

    // Check for international formats with +9471 or +94071
    if (/^947\d{8}$/.test(cleanNumber)) {
        return '07' + cleanNumber.slice(3); 
    }
    if (/^9407\d{8}$/.test(cleanNumber)) {
        return '07' + cleanNumber.slice(4);
    }

    // Check for international formats with 009471 or 0094071
    if (/^00947\d{8}$/.test(cleanNumber)) {
        return '07' + cleanNumber.slice(5); 
    }
    if (/^009407\d{8}$/.test(cleanNumber)) {
        return '07' + cleanNumber.slice(6); 
    }
    return null;

};